import Icons from '@ecomm/shared-icons'
import type { IconTypes } from '@ecomm/shared-icons'

function renderIcon(icon: IconTypes, headline: string) {
  const Icon = Icons[icon]

  return (
    <Icon className="text-neutral-black my-2 w-10 h-10" titleA11y={headline} />
  )
}

type Props = {
  readonly headline: string
  readonly icon: IconTypes
  readonly disclaimer?: string
}

/**
 * A single item in the Confidence Bar component
 * @param icon - The icon to display (from the IconTypes enum)
 * @param headline - The headline text to display
 * @param disclaimer - Optional disclaimer text to display
 * @returns JSX.Element
 */
export function ConfidenceItem({ icon, headline, disclaimer }: Props) {
  return (
    <li
      className="flex w-full flex-row items-start gap-4 lg:flex-col lg:gap-0"
      key={`item-${headline}`}
    >
      <div className="flex flex-col">{renderIcon(icon, headline)}</div>
      <div className="text-neutral-black flex flex-col">
        <h3 className="my-2 lg:mb-5 text-base font-bold md:text-lg">
          {headline}
        </h3>
        {disclaimer ? <small>{disclaimer}</small> : null}
      </div>
    </li>
  )
}
